<template>
	<div ref="imageWrapper" class="images-wrapper">
		<transition name="image-change" mode="out-in">
			<img class="before-image" :src="require(`../assets/images/compare/${beforeImage}`)" alt="Before image" :key="beforeImage" rel="preload" />
		</transition>	
		
		<div class="compare-overlay" :style="{ width: `${compareWidth}%` }">
			<transition name="image-change" mode="out-in">
				<img
					class="after-image"
					:src="require(`../assets/images/compare/${afterImage}`)"
					alt="After image"
					:style="{ width: `${width}px` }"
					rel="preload"
					:key="afterImage"
				/>
			</transition>
		</div>
		<input
			class="compare__range"
			type="range"
			min="0"
			max="100"
			:step="step"
			v-model="compareWidth" 
			tabindex="-1"
		/>
		<div class="handle-wrap" :style="{ left: `${compareWidth}%` }">
			<div class="handle">
				<svg
					class="handle__arrow handle__arrow--l"
					xmlns="http://www.w3.org/2000/svg"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-width="3"
					stroke-linecap="round"
					stroke-linejoin="round"
				>
				<polyline points="15 18 9 12 15 6" />
				</svg>
				<svg
					class="handle__arrow handle__arrow--r"
					xmlns="http://www.w3.org/2000/svg"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-width="3"
					stroke-linecap="round"
					stroke-linejoin="round"
				>
				<polyline points="9 18 15 12 9 6" />
				</svg>
			</div>
		<span class="handle-line"></span>
		</div>
	</div>
</template>
  
  <script>
  export default {
	name: "ComparisonSlider",
	props: {
	  value: {
		type: Number,
		default: 50,
	  },
	  beforeImage: {
		type: String,
		default: "",
	  },
	  afterImage: {
		type: String,
		default: "",
	  },
	  step: {
		type: Number,
		default: 0.1,
	  },
	},
	data() {
	  return {
		width: null,
		compareWidth: this.value,
	  };
	},
	mounted() {
	  this.width = this.$refs.imageWrapper.getBoundingClientRect().width;
	},
	destroyed() {
	},
	methods: {
	},
  };
  </script>
  <style scoped>
  .images-wrapper {
	width: 100%;
	height: 100%;
	position: relative;
  }
  .compare-overlay {
	position: absolute;
	overflow: hidden;
	height: 100%;
	top: 0;
  }
  .before-image,
  .after-image {
	width: 100%;
	height: 100%;
	pointer-events: none;
  }
  .after-image {
	z-index: 2;
	width: 50%;
	position: relative;
  }
  img {
	pointer-events: none;
	user-drag: none;  
   	user-select: none;
   -moz-user-select: none;
   -webkit-user-drag: none;
   -webkit-user-select: none;
   -ms-user-select: none;
  }
  .compare__range {
	position: absolute;
	top: 73%;
	transform: translateY(-50%);
	z-index: 999;
	width: 100%;
	left: 0;
	right: 0;
	height: 50px;
	cursor: ew-resize;
	background: rgba(0, 0, 0, 0.4);
	opacity: 0;
  }
  .handle__arrow {
	position: absolute;
	width: 30px;
	filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.2));
  }
  .handle__arrow--l {
	left: 0;
  }
  .handle__arrow--r {
	right: 0;
  }
  .handle-wrap {
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	top: 73%;
	height: 100%;
	transform: translate(-50%, -50%);
	z-index: 2;
  }
  .handle {
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	background: var(--yellow);
	border-radius: 50%;
	width: 60px;
	height: 60px;
	box-shadow: 0 0 20px rgb(0 0 0 / 0.2);
  }
  .handle-line {
	content: "";
	position: absolute;
	top: 0;
	width: 2px;
	height: 100%;
	z-index: 4;
	pointer-events: none;
	user-select: none;
  }
  @media screen and (max-width: 568px) {
	.handle {
	  width: 25px;
	  height: 25px;
	}
	.handle__arrow {
	  width: 20px;
	}
  }
  @media screen and (max-width: 480px) {
	.handle {
	  width: 15px;
	  height: 15px;
	}
	.handle__arrow {
	  width: 10px;
	}
  }
  </style>